export const IMPERSONATION_BANNER_ID = "impersonation-banner"
